import React from "react";

const EventForm = ({ newEvent, onChange, onAdd, disabled }) => {
  const set = (field) => (e) => onChange(field, e.target.value);

  return (
    <section>
      <header className="mb-4 flex items-baseline justify-between">
        <span className="section-eyebrow">Add event</span>
      </header>

      <div className="grid grid-cols-12 gap-3">
        <div className="field col-span-2">
          <label className="label">Line</label>
          <input
            type="text"
            value={newEvent.line}
            onChange={set("line")}
            placeholder="A1"
            className="input-mono"
            disabled={disabled}
          />
        </div>

        <div className="field col-span-10 md:col-span-5">
          <label className="label">Operation</label>
          <input
            type="text"
            value={newEvent.operation}
            onChange={set("operation")}
            placeholder="Describe the operation"
            className="input"
            disabled={disabled}
          />
        </div>

        <div className="field col-span-6 md:col-span-2">
          <label className="label">Est. hrs</label>
          <input
            type="number"
            value={newEvent.estimatedHours}
            onChange={set("estimatedHours")}
            placeholder="0"
            className="input-mono"
            disabled={disabled}
          />
        </div>

        <div className="field col-span-6 md:col-span-2">
          <label className="label">Actual hrs</label>
          <input
            type="number"
            value={newEvent.actualHours}
            onChange={set("actualHours")}
            placeholder="0"
            step="0.01"
            className="input-mono"
            disabled={disabled}
          />
        </div>

        <div className="field col-span-12">
          <label className="label">Remarks</label>
          <input
            type="text"
            value={newEvent.remarks}
            onChange={set("remarks")}
            placeholder="Optional notes"
            className="input"
            disabled={disabled}
          />
        </div>

        <div className="col-span-12 flex justify-end">
          <button
            type="button"
            onClick={onAdd}
            disabled={disabled}
            className="btn-primary"
          >
            Add event
          </button>
        </div>
      </div>
    </section>
  );
};

export default EventForm;
